export const IconPeople = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="6" r="3" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
            <path
                d="M8 20.9993V15.9994C8 13.7903 9.79086 11.9995 12 11.9995C14.2091 11.9995 16 13.7903 16 15.9994V20.9993"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5 13.9995C3.89543 13.9995 3 14.8949 3 15.9995V20.9995"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19 13.9995C20.1046 13.9995 21 14.8949 21 15.9995V20.9995"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="5" cy="9" r="2" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
            <circle cx="19" cy="9" r="2" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        </svg>
    );
};
